"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketPolicyOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketPolicyOutput.js.map